import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = typeof window !== 'undefined'
    ? window.localStorage.getItem('quran-player-admin-token')
    : null;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getQalunSurahPages = (surahNumber) => api.get(`/qalun/surahs/${surahNumber}/pages`);

export const getMutashabihat = (throughPage) => api.get('/mutashabihat', {
  params: throughPage ? { through_page: throughPage } : {},
});

// Surah API
export const getSurahs = () => api.get('/surahs');
export const getSurah = (id) => api.get(`/surahs/${id}`);
export const createSurah = (data) => api.post('/surahs', data);
export const updateSurah = (id, data) => api.put(`/surahs/${id}`, data);
export const deleteSurah = (id) => api.delete(`/surahs/${id}`);

// Excerpt API
export const getExcerpts = (surahId) => api.get(`/surahs/${surahId}/excerpts`);
export const getExcerpt = (id) => api.get(`/excerpts/${id}`);

export const createExcerpt = async (formData) => {
  return api.post('/excerpts', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateExcerpt = (id, data) => api.put(`/excerpts/${id}`, data);

export const replaceExcerptAudio = async (id, formData) => {
  return api.put(`/excerpts/${id}/audio`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteExcerpt = (id) => api.delete(`/excerpts/${id}`);
export const reorderExcerpts = (surahId, excerptIds) => 
  api.put(`/surahs/${surahId}/reorder`, { excerpt_ids: excerptIds });

// Admin Auth API
export const checkAdminSetup = () => api.get('/admin/check');
export const setupAdmin = (password) => api.post('/admin/setup', { password });
export const adminLogin = (password) => api.post('/admin/login', { password });
export const adminLogout = (token) => {
  const formData = new FormData();
  formData.append('token', token);
  return api.post('/admin/logout', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
export const verifyAdminToken = (token) => api.get(`/admin/verify?token=${token}`);

// Audio URL helper
export const getAudioUrl = (fileId) => `${API_URL}/api/audio/${fileId}`;

export default api;
